import AbstractUser from "./AbstractUser";

export default class Editor extends AbstractUser {
    private readonly _language: string|null;
    private readonly _photo: object|null;

    constructor({
        id,
        name,
        firstName,
        infix,
        lastName,
        links,
        photo
    }, language = null) {
        super({
            id,
            name,
            firstName,
            infix,
            lastName,
            links,
        });

        this._photo = photo;
        this._language = language;
    }

    get language(): string|null {
        return this._language;
    }

    get photo(): object|null {
        return this._photo;
    }
}
